__turbopack_context__.v({
  "deleted": "qtUfxq_deleted",
  "edit": "qtUfxq_edit",
  "maintainerBadge": "qtUfxq_maintainerBadge",
  "name": "qtUfxq_name",
  "nameAndFunds": "qtUfxq_nameAndFunds",
  "nameAndTagline": "qtUfxq_nameAndTagline",
  "profile": "qtUfxq_profile",
  "profileLogo": "qtUfxq_profileLogo",
  "raisingFundsWeb": "qtUfxq_raisingFundsWeb",
  "root": "qtUfxq_root",
  "tagline": "qtUfxq_tagline",
});
